import { TourModel } from 'api-hooks/tour/tour-list/tour-detail';
import { AuthorizationRules } from 'common/constants';
import { PopoverMenuType } from 'components/popover';
import { useAuthorization } from 'hooks/use-authorization';
import useDrawer, { DrawerProvider } from 'hooks/use-drawer';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';

import ListParticipantPanel from '../panel/participant-list-panel';

export default function useTourParticipantAction(tour: TourModel) {
  const { t } = useTranslation();
  const { can } = useAuthorization();
  const drawer = useDrawer();

  const id = tour.id;

  const tourParticipantPermission = can(AuthorizationRules.ToursGetParticipant);

  const onGetTourParticipant = React.useCallback(() => {
    drawer.showCustom({
      render: (onClose) => (
        <DrawerProvider>
          <ListParticipantPanel id={id} onClose={onClose} />
        </DrawerProvider>
      ),
    });
  }, [drawer, id]);

  const tourParticipantAction: PopoverMenuType = {
    key: `tour-participant-${id}`,
    label: t('common:participant_list'),
    isAllowed: tourParticipantPermission,
    onClick: onGetTourParticipant,
  };

  return {
    onGetTourParticipant,
    tourParticipantPermission,
    tourParticipantAction,
  };
}
